"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.wip.title': '开发中',
    'socialMediaPlan.wip.description': '社交媒体规划功能即将推出。',
};
